import { classNames } from 'primereact/utils';
import React from 'react';
import { IconTooltip } from '../IconTooltip';

type LabelProps = {
    htmlFor: string;
    text: string;
    required?: boolean;
    warning?: React.ReactNode;
    info?: React.ReactNode;
    className?: string;
};

export const Label = ({ htmlFor, text, required, warning, info, className }: LabelProps) => {
    return (
        <label htmlFor={htmlFor} className={classNames('label', { 'label--required': required }, className)}>
            {text}
            {required && '*'}
            {info && <IconTooltip>{info}</IconTooltip>}
            {warning && <IconTooltip warning>{warning}</IconTooltip>}
        </label>
    );
};
